// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2080":"fce8319a","8777":"8da9171f","9586":"fce8319a"}[chunkId] + ".chunk.css";
};